import ol , {Feature} from 'ol'
import Geometry from 'ol/geom/Geometry'
import LineString from 'ol/geom/LineString'
import { Pixel } from 'ol/pixel'
export class GeometryHelpers {
    public static isLineStringFeature(feature: ol.Feature<Geometry>): feature is ol.Feature<LineString> {
        return feature.getGeometry() instanceof LineString
    }

    public static isVeryClose(a: Pixel, b: Pixel): boolean {
        return GeometryHelpers.distanceBetween(a, b) <= 12
    }

    public static isCloseEnoughToSnapToRoad(a: Pixel, b: Pixel): boolean {
        return GeometryHelpers.distanceBetween(a, b) <= 30
    }

    private static distanceBetween(a: Pixel, b: Pixel) {
        const dx = a[0] - b[0]
        const dy = a[1] - b[1]
        const distance = Math.sqrt(dx * dx + dy * dy)
        return distance
    }
}